module.exports = __webpack_public_path__ + "img/Certificate.55074146.svg";